/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import ApiCalls from '../../custom-classes/api-calls';
import Select from 'react-select';


/**
 * Handles the selection of the students. Uses react-select, which allow the user to writes whatever he want to search
 */
class SelectorStudent extends React.Component{

    constructor(props)
    {
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);

        let languages = [
            { name: "English", code: "en" },
            { name: "Español", code: "es" }
        ];

        this.state = {
            options: [], // The options to fill the selection
            languages: languages,
            value: null
        };
    }

    /**
     * Call the profiles api and create the selection according to it
     */
    componentDidMount()
    {
        // This is promise
        let apiCall = ApiCalls.getProfiles();
        let arrOptions = [];

        // After the api call, fill the data
        apiCall.then((data)=>{

            console.log(data);
            let dataReturned = data.ProfilesAccountModelList;

            // Now fill the selections
            for (let i = 0; i < dataReturned.length; i++)
            {
                arrOptions.push({ value: dataReturned[i].UserAccountModel.Id,
                    label: dataReturned[i].UserFullNameModel.Surname + ', ' + dataReturned[i].UserFullNameModel.GivenName + ' ('
                    + dataReturned[i].UserAccountModel.Username + ')' });
            }
        }).then(()=>{
            // Then, set the state
            this.setState({
                options: arrOptions
            });
        });
    }

    /**
     * Handles the change
     * @param selectedOption
     */
    handleChange = (selectedOption) => {
        this.setState({value: selectedOption }, ()=>{
            this.props.updateParent(this.state.value);
            return this.state.value;
        });
    };

    /**
     * Renders the item list
     * @returns {XML} Returns an XML of the selection
     */
    render(){
        return (
            <Select onChange={this.handleChange} value={this.props.value} options={this.state.options}/>
        )
    }
}

export default SelectorStudent;


// WEBPACK FOOTER //
// ./src/components/selectors/selector-student.js